<template>
<div class="container flex flex-column align-items-center" :class="{'mt-11' : !$mq.isDesktop()}" v-show="!loading">
  <h2 class="mt-10 text-center">Ecco la nostra bottega</h2>
  <p class="text-center">Ogni settimana prodotti genuini di alta qualità a casa tua</p>
  <div 
    class="flex justify-content-center flex-wrap mx-auto"
  >
    <router-link         
      v-for="(section, i) in sections.items.slice(0,11)"
      :key="i"
      :to="{ name: 'shop-by-tag', params: {tag: section.url} }"
      class="section-links"
      >
        <v-card 
          class="mx-3 my-3 section-cards"
        >
          <v-img :src="section.img" height="200px"></v-img>
          <v-card-title v-text="section.name"></v-card-title>
        </v-card>
    </router-link>
  </div>
  <checkout-footer :recipesFooter="false"/>
</div>
</template>

<script>
import CheckoutFooter from './CheckoutFooter'

import { menuStore } from '../../store/menuStore' 

export default {
  components: { 
    CheckoutFooter 
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    sections () {
      let sections = JSON.parse(window.config["quomi.checkout.new-top-sections"])

      // @todo, in case of multiple shops with multiple or different steps based on source convert this and routing
      sections = sections.find(el => {return el.name === 'Bottega' })
    
      return sections
    },
  },
  mounted() {
    this.loading = true;
    menuStore.loadCurrentMenu().then(i => {
      return menuStore.redirectHandler()
    }).then(i => {
      this.loading = false;
    })
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .section-cards {
    width: 300px;
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .section-cards {
    max-width: 200px;
  }
}

@media (max-width: 426px) {
  .section-links {
    width: 50%
  }

  .v-image.v-responsive.theme--light {
    height: unset !important;
  }

  .v-card__title {
    font-size: x-small !important;
    font-weight: bold;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
}
</style>